import { ActivityCode } from '@eppendorf/vnls-audit-event-client';
import { Dialog, Icon } from '@eppendorf/vnls-react-components';

import { getIconNameForActivityCode as getIconPropsForActivityCode } from '$features/audit-events/audit-events.utils';

import styles from './audit-event-detail.module.scss';

export interface AuditEventDetailHeaderProps {
  activityName?: string;
  activityCode: ActivityCode;
}

export function AuditEventDetailHeader({
  activityName,
  activityCode,
}: AuditEventDetailHeaderProps) {
  const { name, size } = getIconPropsForActivityCode(activityCode);
  return (
    <div className={styles.auditEventDetailHeader}>
      <Icon name={name} size={size} />
      <Dialog.Title className="m-bottom-none">{activityName}</Dialog.Title>
    </div>
  );
}
